// MF-67 — Journal routes in one place. Entries live at /journal/entries; every configuration screen
// (types → severities → zones → categories → templates) lives under the tabbed Configuration page.
export const JOURNAL_BASE = '/dashboard/journal'
export const ENTRIES_PATH = `${JOURNAL_BASE}/entries`
export const CONFIG_PATH = `${JOURNAL_BASE}/configuration`
export const configPath = (tab, suffix = '') => `${CONFIG_PATH}/${tab}${suffix ? `/${suffix}` : ''}`
